import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FieldTypes } from 'projects/shared/src/models/global/FieldTypes';
import { SwalService } from 'projects/shared/src/services/swal.service';
import { SubmitReasonComponent } from 'projects/admin/src/app/shared/components/submit-reason/submit-reason.component';
import { MatDialog } from '@angular/material/dialog';
import { SurveysOpinionTaskService } from '../../../services/surveys-opinion-task.service';
import { SurveyOpinionTaskStatusEnum } from '../../../models/surveys-tasks/enums/SurveyOpinionTaskStatusEnum';
import { SurveyTaskDetails } from '../../../models/surveys-tasks/SurveyTaskDetails';
import { Action, AvailableActions } from '../../../models/surveys-tasks/AvailableActions';
import { TaskActionData } from '../../../models/surveys-tasks/TaskActionData';

@Component({
  selector: 'app-survey-tasks-actions',
  standalone: false,
  templateUrl: './survey-tasks-actions.component.html'
})
export class SurveyTasksActionsComponent implements OnInit {
  @Input({ required: true }) record: SurveyTaskDetails = new SurveyTaskDetails();
  @Input() isAmbassador = false;
  availableActions: AvailableActions = new AvailableActions();
  taskStatus = SurveyOpinionTaskStatusEnum;
  loading = false

  constructor(
    public dialog: MatDialog,
    private swalService: SwalService,
    private translate: TranslateService,
    private service: SurveysOpinionTaskService
  ) { }

  ngOnInit() {
    this.getAvailableActions();
  }

  getAvailableActions() {
    this.service.getAvailableActions(this.record.taskId).subscribe((data) => {
      this.availableActions = data as AvailableActions;
    }, (error: any) => {

    })
  }

  handleClick(action: Action) {
    switch (action.apiName) {
      case 'ChangeTaskStatus':
        this.ChangeTaskStatus(action);
        break;
      default:
        let data = {
          taskId: this.record.taskId,
          nextStatus: action.nextStatus,
          actionId: action.actionId,
          reason: ""
        }
        //  this.ChangeTaskStatus(data)
        break;
    }
  }

  ChangeTaskStatus(action: Action) {
    let data = {} as TaskActionData;
    switch (action.nextStatus) {
      case SurveyOpinionTaskStatusEnum.Modifications_Requested_From_First_Review:
      case SurveyOpinionTaskStatusEnum.Modifications_Requested_From_Final_Review:
      case SurveyOpinionTaskStatusEnum.Final_Report_Rejected:
        this.requestEdit(action);
        break;
      case SurveyOpinionTaskStatusEnum.Final_Report_Approved:
        this.confirmApprove(action);
        break;
      default:
        data = {
          actionId: action.actionId,
          taskId: this.record.taskId,
          nextStatus: action.nextStatus,
          reason: ""
        };
        let title = this.translate.instant('swalMsg.Success');
        let message = '';
        if (action.nextStatus === SurveyOpinionTaskStatusEnum.Waiting_First_Review) {
          title = this.translate.instant('surveyTasks.responsesSubmittedForReview');
          message = this.translate.instant('surveyTasks.reviewNotificationNotice');
        } else if (action.nextStatus === SurveyOpinionTaskStatusEnum.Waiting_Final_Approval) {
          title = this.translate.instant('swalMsg.finalReviewApprovedSuccessfully');
        }
        else if (action.nextStatus === SurveyOpinionTaskStatusEnum.Waiting_Final_Review) {
          title = this.translate.instant('swalMsg.firstReviewApprovedSuccessfully');
          // message = this.translate.instant('verificationTasks.evaluationHasBeenApprovedSuccessfully');
        }
        this.confirmationAction(data, title, message);
        break;
    }
  }

  requestEdit(action: Action) {
    const rejectRequest = action.nextStatus === SurveyOpinionTaskStatusEnum.Final_Report_Rejected;
    const dataRecord = {
      title: this.translate.instant('monitoringTasks.' + (rejectRequest ? 'rejectRequest' : 'modificationRequest')),
      btnSubmitTitle: this.translate.instant('general.confirm'),
      showClose: true,
      service: this.service,
      serviceTarget: 'changeTaskStatus',
      hideSwalMessageSuccess: true,
      record: {
        actionId: action.actionId,
        taskId: this.record.taskId,
        nextStatus: action.nextStatus
      },
      fields: [
        {
          id: 'reason',
          inputTypeId: FieldTypes.TEXTAREA,
          inputTitle: rejectRequest ? this.translate.instant('monitoringTasks.rejectionReason') : this.translate.instant('rights.editRequestReason'),
          value: null,
          isMandatory: true,
          fieldLength: 1000,
          minLength: 3
        }
      ],
    };
    let title = this.translate.instant('rights.editRequestSentSuccessfully');
    if (rejectRequest) {
      title = this.translate.instant('swalMsg.surveyTaskResultsRejectedSuccessfully');
    }
    this.openForm(dataRecord, title);
  }

  openForm(dataRecord: any, title: string, message = '') {
    const dialogRef = this.dialog.open(SubmitReasonComponent, {
      width: '540px',
      data: dataRecord,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.service.refreshDetails.next(true);
        this.swalService.swalSuccess(message, this.translate.instant('swalMsg.Ok'), title);
      }
    });
  }

  confirmApprove(action: Action) {
    const title = this.translate.instant('swalMsg.surveyTaskResultsApprovedSuccessfully');
    const confirmTitle = this.translate.instant('swalMsg.confirmApproveSurveyTaskResults');
    const data = {
      actionId: action.actionId,
      taskId: this.record.taskId,
      nextStatus: action.nextStatus,
      reason: ""
    };
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), confirmTitle).then((result) => {
      if (result.value) {
        this.loading = true;
        this.service.changeTaskStatus(data).subscribe(
          (res: any) => {
            this.loading = false;
            this.service.refreshDetails.next(true);
            this.swalService.swalSuccess('', this.translate.instant('swalMsg.Ok'), title);
          },
          (err: any) => {
            this.loading = false;
            this.handleErrors(err.detail);
          }
        );
      }
    });
  }

  confirmationAction(data: TaskActionData, title: string = this.translate.instant('swalMsg.Success'), message = '') {
    this.swalService.swalConfirmation(this.translate.instant('swalMsg.yes sure'), this.translate.instant('swalMsg.Areyousure')).then((result) => {
      if (result.value) {
        this.loading = true;
        // const formData = new FormData();
        // formData.append('data', JSON.stringify(data));
        this.service.changeTaskStatus(data).subscribe(
          (res: any) => {
            this.loading = false;
            this.service.refreshDetails.next(true);
            this.swalService.swalSuccess(message, this.translate.instant('swalMsg.Ok'), title);
          },
          (err: any) => {
            this.loading = false;
            this.handleErrors(err.detail);
          }
        );
      }
    });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      this.swalService.swalFailed(error.Error);
    });
  }
}
